export default __webpack_public_path__ + "static/media/house_two.fde4ea5f.jpg";